export const ACTION_BAR_ICON_MOBILE_SIZE = 2;
export const ACTION_BAR_ICON_DESKTOP_SIZE = 4;
